import React from "react";
import { Filter, TextInput } from "react-admin";

const UserQueryFilter = ({ permissions, ...props }) => (
  <Filter {...props}>
    <TextInput label="Search by UserId" source="user_id" alwaysOn />
    <TextInput label="Search by Resolved (0/1)" source="resolved" alwaysOn />
    <TextInput label="Search by Phone" source="phone" alwaysOn />
  </Filter>
);

export default UserQueryFilter;
